<template>
  <div class="indexBg">
    <div
      class="return"
      :class="{ active: isReturn }"
      @mousedown="handlePressReturn(true)"
      @mouseup="handlePressReturn(false)"
      @mouseleave="handlePressReturn(false)"
      @touchstart="handlePressReturn(true)"
      @touchend="handlePressReturn(false)"
      @touchcancel="handlePressReturn(false)"
      @click="goReturn"
    ></div>
        <div
      class="btnRight"
      :class="{ active: isRight }"
      @mousedown="handlePressRight(true)"
      @mouseup="handlePressRight(false)"
      @mouseleave="handlePressRight(false)"
      @touchstart="handlePressRight(true)"
      @touchend="handlePressRight(false)"
      @touchcancel="handlePressRight(false)"
      @click="goRecord"
    >
      测评记录
    </div>
    <div
      class="btnLeft"
      :class="{ active: isLeft }"
      @mousedown="handlePressLeft(true)"
      @mouseup="handlePressLeft(false)"
      @mouseleave="handlePressLeft(false)"
      @touchstart="handlePressLeft(true)"
      @touchend="handlePressLeft(false)"
      @touchcancel="handlePressLeft(false)"
      @click="introduce"
    >
      活动介绍
    </div>
    <div
      class="enter"
      :class="{ active: isActive }"
      @mousedown="handlePress(true)"
      @mouseup="handlePress(false)"
      @mouseleave="handlePress(false)"
      @touchstart="handlePress(true)"
      @touchend="handlePress(false)"
      @touchcancel="handlePress(false)"
      @click="goEnter"
      id="van-notify"
    >
      进入测评
    </div>

    <van-dialog
      use-slot
      v-model:show="show"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="introduceDialog">
        <div class="introduceHeader">
          <div class="introduceImg"></div>
        </div>
        <div class="introduceContent" v-html="introduceHtml"></div>
        <div class="introduceBtn" @click="onClose">我知道了</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Notify } from 'vant' // 添加这行导入
import { getPublic } from '@/api/index'
export default {
  name: 'indexPage',
  data () {
    return {
      isActive: false,
      isReturn: false,
      isLeft: false,
      isRight: false,
      isOver: false,
      show: false,
      introduceHtml: ''
    }
  },
  created () {
    // 获取 deviceCode：正式环境从 URL 获取，测试环境使用固定值
    const urlParams = new URLSearchParams(window.location.search)
    const deviceCodeFromUrl = urlParams.get('deviceCode')
    const deviceCode = deviceCodeFromUrl || 'a034e84a93526854' // 测试环境默认值

    // 调用 getPublic 接口，传递 deviceCode
    this.getPublic(deviceCode)

    if (deviceCode) {
      this.$store.dispatch('updateDeviceInfo', {
        deviceCode
      })
    }
  },
  mounted () {},

  methods: {
    introduce () {
      this.show = true
    },

    onClose () {
      this.show = false
    },
    handlePress (state) {
      this.isActive = state
    },
    handlePressReturn (state) {
      this.isReturn = state
    },
    handlePressLeft (state) {
      this.isLeft = state
    },
    handlePressRight (state) {
      this.isRight = state
    },
    getPublic (deviceCode) {
      getPublic(deviceCode).then((res) => {
        if (res.data.code === 200) {
          this.isOver = res.data.data.isOver
          this.introduceHtml = res.data.data.description
          const testId = res.data.data.testId
          if (testId) {
            this.$store.dispatch('updateDeviceInfo', {
              testId
            })
          }
        } else {
          Notify({
            message: res.data.msg,
            duration: 1000
          })
        }
      })
    },

    introduce () {
      this.show = true
    },

    goReturn () {
      // this.$router.go(-1); // 返回上一页
      const eventData = {
        type: 'home',
        timestamp: new Date().toISOString()
      }
      window.parent.postMessage(eventData, '*')
    },
    goEnter () {
      if (this.isOver) {
        Notify({
          message: '测评已结束，请等待下次活动开启！',
          duration: 1000
        })
      } else {
        this.$router.push({
          path: '/evaluation'
        })
      }
    },
    goRecord () {
      this.$router.push({
        path: '/record'
      })
    },
    goLeft () {},
    goRight () {}
  }
}
</script>

<style scoped lang="less">
.indexBg {
  width: 100%;
  height: 100vh;
  background: url("@/assets/indexBg.png") no-repeat center / 100% 100%;
}
.return {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 80px;
  height: 80px;
  background: url("@/assets/return.png") no-repeat center / 100% 100%;
}
.btnLeft {
  position: absolute;
  bottom: 7%;
  left: 5%;
  width: 210px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 38px;
  // font-family: Alibaba-PuHuiTi-Regular;
  font-weight: 700;
  background: url("@/assets/btnBg.png") no-repeat center / 100% 100%;
}
.btnLeft,
.btnRight {
  position: absolute;
  bottom: 7%;
  left: 5%;
  width: 210px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 38px;
  font-family: Alibaba-PuHuiTi-Regular;
  font-weight: 700;
  background: url("@/assets/btnBg.png") no-repeat center / 100% 100%;
  border-radius: 12px;
  box-shadow: inset 0px -1px 18px 0px rgba(0, 60, 102, 0.26),
    0px 10px 12px 0px rgba(82, 130, 255, 0.19);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1),
    rgba(211, 226, 255, 1) 100%
  );
}
.btnRight {
  left: 68%;
}
.enter {
  position: absolute;
  bottom: 7%;
  left: 36.5%;
  width: 210px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 38px;
  font-family: Alibaba-PuHuiTi-Regular;
  font-weight: 700;
  background: url("@/assets/enterBg.png") no-repeat center / 100% 100%;
  transition: background 0.2s ease; /* 添加过渡效果使变化更平滑 */
  border-radius: 12px;
  box-shadow: inset 0px -1px 18px 0px rgba(0, 60, 102, 0.26),
    0px 10px 12px 0px rgba(82, 130, 255, 0.37);
  background: linear-gradient(
    180deg,
    rgba(78, 157, 255, 1),
    rgba(12, 104, 255, 1) 100%
  );
}
.return.active {
  background: url("@/assets/returnOver.png") no-repeat center / 100% 100%;
}
.enter.active {
  color: #c2c2c2;
  background: url("@/assets/enterBgOver.png") no-repeat center / 100% 100%;
}
.btnLeft.active,
.btnRight.active {
  color: #3f3f3f;
  background: url("@/assets/btnBgOver.png") no-repeat center / 100% 100%;
}
.introduceDialog {
  margin: 0 auto;
  .introduceHeader {
    height: 100px;
    padding: 30px 40px 0px 40px;
    background: linear-gradient(
      180deg,
      rgba(177, 219, 255, 1),
      rgba(255, 255, 255, 0) 100%
    );
    .introduceImg {
      width: 100%;
      height: 60px;
      background: url("@/assets/introduceHeader.png") no-repeat center / 100%
        100%;
    }
  }
  .introduceContent {
    padding: 0 30px 10px 30px;
    max-height: 63vh;
    overflow-y: auto;
  }
  .introduceBtn {
    width: 320px;
    height: 80px;
    font-family: Alibaba-PuHuiTi-Regular;
    font-size: 40px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 20px;
    background: url("@/assets/submit.png") no-repeat center / 100% 100%;
  }
}
</style>
